import React, { ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';

const DEFAULT_LOGO_URL = 'https://p1.liveauctioneers.com/dist/images/logo_og.jpg';

export type PageHeaderMetaProps = {
    readonly canonical: string;
    readonly children?: ReactNode;
    readonly description?: string;
    readonly imageUrl?: string;
    readonly ogUrl?: string;
    readonly title: string;
};

const PageHeaderMetaBase = ({
    canonical,
    children,
    description = '',
    imageUrl = '',
    ogUrl = '',
    title,
}: PageHeaderMetaProps) => {
    const image = imageUrl === '' ? DEFAULT_LOGO_URL : imageUrl;

    const showDescription = description !== '';

    return (
        <Helmet>
            <link
                href={canonical}
                rel="canonical"
            />
            {showDescription && (
                <meta
                    content={description}
                    name="description"
                />
            )}
            <title>{title}</title>

            {showDescription && (
                <meta
                    content={description}
                    property="og:description"
                />
            )}
            <meta
                content={title}
                property="og:title"
            />
            <meta
                content={ogUrl ? ogUrl : canonical}
                property="og:url"
            />
            <meta
                content={image}
                property="og:image"
            />
            <meta
                content={image}
                property="og:image:secure_url"
            />

            {showDescription && (
                <meta
                    content={description}
                    name="twitter:description"
                />
            )}
            <meta
                content={title}
                name="twitter:title"
            />
            <meta
                content={image}
                name="twitter:image"
            />

            {children}
        </Helmet>
    );
};

export const PageHeaderMeta = React.memo<PageHeaderMetaProps>(PageHeaderMetaBase);
